import React from 'react'
// import KrpanoPlayer from '../DigitalTwin/KrpanoPlayer'
import { Button, Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

const HomeOffice = (props) => {
    
  return (
    <>
        <div id="home-office" className="container home-office-container">
            <Row >
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}}>
                    <Card className='no-border rounded-0'>
                        <Card.Title className='home-office-main-title'>Home Office</Card.Title>
                        <Card.Text className='home-office-text-content'>
                        With work transitioning from on - site office workstations to remote home offices during the pandemic, we also created a digital twin of a client’s home office with exacting detail , down to an ear bud he a dset and Apple watch.
                        </Card.Text>
                        <Button className='home-office-360-button btn btn-warning'><a href="/krpano-player" ><img className='img-fluid threesixty-icon' src={process.env.PUBLIC_URL + "assets/icons/360.png"} alt="360 icon" />View in 360</a></Button>
                    </Card>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:8, offset:0}} className="home-office-slider-container">
                    <Carousel className='home-office-carousel' indicators={false} interval={null} >
                        <CarouselItem className='home-office-carousel-item'>
                            <Card className='no-border rounded-0'>
                                <Row>
                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Img className='home-office-first-image' src={process.env.PUBLIC_URL + "assets/digital-twin/home-office/Seperated/office01.jpg"}  alt="" />
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Img className='' src={process.env.PUBLIC_URL + "assets/digital-twin/home-office/Seperated/office01_1.jpg"}  alt="" />
                                    </Col>

                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Text className='home-office-carousel-title'>Real Life <br /> Reference Photo</Card.Text>
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Text className='home-office-carousel-title'>Virtual Image Rendered <br /> From 3D Models</Card.Text>
                                    </Col>
                                </Row>
                            </Card>
                        </CarouselItem>
                        <CarouselItem className='home-office-carousel-item-middle'>
                            <Card className='no-border rounded-0'>
                                <Row>
                                    <Col xs={{span:6, offset:3}}>
                                        <Card.Img className='' src={process.env.PUBLIC_URL + "assets/digital-twin/home-office/Seperated/office03_1.jpg"}  alt="" />
                                    </Col>
                                </Row>
                            </Card>
                        </CarouselItem>
                        <CarouselItem className='home-office-carousel-item'>
                            <Card className='no-border rounded-0'>
                                <Row>
                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Img className='home-office-first-image' src={process.env.PUBLIC_URL + "assets/digital-twin/home-office/Seperated/office02.jpg"}  alt="" />
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Img className='' src={process.env.PUBLIC_URL + "assets/digital-twin/home-office/Seperated/office02_1.jpg"}  alt="" />
                                    </Col>
                                    <Col xs={{span:4, offset:1}}>
                                        <Card.Text className='home-office-carousel-title'>Real Life <br /> Reference Photo</Card.Text>
                                    </Col>
                                    <Col xs={{span:6, offset:0}}>
                                        <Card.Text className='home-office-carousel-title'>Virtual Image Rendered <br /> From 3D Models</Card.Text>
                                    </Col>
                                </Row>
                            </Card>
                        </CarouselItem>
                    </Carousel>
                </Col>
            </Row>
        </div>
        
    </>
  )
}

export default HomeOffice
